module.exports = __webpack_public_path__ + "static/media/22ESCWA3.f91708a1.jpg";